import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { StarFill, Quote } from "react-bootstrap-icons";

const Testimonials = () => {
    const testimonials = [
        {
            name: "Juan Pérez",
            text: "La calidad de los bolsos es impresionante. No solo son cómodos, sino que también tienen un diseño moderno. ¡Muy recomendado!",
            rating: 5,
            city: "Bogotá"
        },
        {
            name: "María García",
            text: "El servicio al cliente fue excepcional. Me ayudaron a encontrar justo lo que estaba buscando y el envío fue muy rápido.",
            rating: 5,
            city: "Medellín"
        },
        {
            name: "Karla López",
            text: "Nunca pensé que un morral podría tener tanta calidad a ese precio. Me encanta cómo se ajusta y el diseño está a otro nivel.",
            rating: 5,
            city: "Cali"
        },
    ];

    const renderStars = (rating) => {
        return [...Array(5)].map((_, i) => (
            <StarFill 
                key={i} 
                size={16} 
                className={i < rating ? "text-warning" : "text-secondary"} 
            />
        ));
    };

    return (
        <div className="py-5">
            <Container>
                <div className="text-center mb-5">
                    <h2 className="text-uppercase color-primary mb-3 fs-6">Testimonios</h2>
                    <h3 className="fw-bold color-primary fs-2">Lo que dicen nuestros clientes</h3>
                    <p className="text-muted mt-3 mx-auto" style={{ maxWidth: '600px' }}>
                        Miles de clientes satisfechos nos respaldan. Descubre por qué son nuestra mejor recomendación.
                    </p>
                </div>
                
                <Row>
                    {testimonials.map((testimonial, index) => (
                        <Col md={6} lg={4} key={index} className="mb-4">
                            <Card className="h-100 border-0 shadow-sm" style={{ borderRadius: '16px', background: '#e7e2da', color: '#2E0205' }}>
                                <Card.Body className="p-4" >
                                    {/* Quote icon */}
                                    <Quote size={32} className="color-primary mb-3" />
                                    
                                    {/* Stars */}
                                    <div className="mb-3">
                                        {renderStars(testimonial.rating)}
                                    </div>
                                    
                                    {/* Testimonial text */}
                                    <Card.Text className="text-muted mb-4" style={{ fontStyle: 'italic', lineHeight: '1.8' }}>
                                        "{testimonial.text}"
                                    </Card.Text>
                                    
                                    {/* Divider */}
                                    <hr className="my-3" style={{ borderColor: '#2E0205' }} />
                                    
                                    {/* Author info */}
                                    <div className="d-flex align-items-center">
                                        <div 
                                            className="rounded-circle d-flex align-items-center justify-content-center color-secundary fw-bold"
                                            style={{ 
                                                width: '50px', 
                                                height: '50px', 
                                                backgroundColor: '#2E0205',
                                                fontSize: '18px'
                                            }}
                                        >
                                            {testimonial.name.charAt(0)}
                                        </div>
                                        <div className="ms-3">
                                            <Card.Title className="mb-0 fw-bold color-primary" style={{ fontSize: '16px' }}>
                                                {testimonial.name}
                                            </Card.Title>
                                            <small className="text-muted">{testimonial.city}</small>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
};

export default Testimonials;
